import { TranslationObject } from 'ontime-types';

export const langEs: TranslationObject = {
  'common.expected_finish': 'Finalización esperada',
  'common.minutes': 'min',
  'common.seconds': 'sec',
  'common.now': 'Ahora',
  'common.next': 'Siguiente',
  'common.scheduled_start': 'Inicio programado',
  'common.scheduled_end': 'Fin programado',
  'common.expected_start': 'Inicio previsto',
  'common.expected_end': 'Fin previsto',
  'common.timer_message': 'Mensaje del temporizador',
  'common.secondary_message': 'Mensaje secundario',
  'common.stage_timer': 'Temporizador de presentador',
  'common.started_at': 'Iniciado en',
  'common.time_now': 'Ahora',
  'common.no_data': 'Sin datos',
  'countdown.ended': 'Evento finalizado a las',
  'countdown.running': 'Evento en curso',
  'countdown.group_running': 'Evento en grupo en curso',
  'countdown.loaded': 'Evento está cargado', //TODO: check translation
  'countdown.select_event': 'Seleccionar un evento para seguir',
  'countdown.to_start': 'Tiempo para comenzar',
  'countdown.waiting': 'Esperando el inicio del evento',
  'countdown.overtime': 'en tiempo extra',
  'countdown.all_have_finished': 'Todos los eventos seleccionados han terminado',
  'timeline.live': 'live',
  'timeline.done': 'Terminado',
  'timeline.due': 'pendiente',
  'timeline.followedby': 'Seguido por',
  'timeline.standby': 'En espera',
  'project.title': 'Título',
  'project.description': 'Descripción',
  'project.info': 'Información del proyecto',
  'project.url': 'URL del proyecto',
};
